import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useParams} from "react-router-dom";
import {usePaymentProfile} from "../hooks/usePaymentProfile.ts";
import {PaymentProfileStatus} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {id: customerId} = useParams()

    if (!customerId) {
        throw new Error('customerId is required')
    }

    const {
        createRecord,
    } = usePaymentProfile();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                status: PaymentProfileStatus.Active,
                customerId: customerId,
                billingProviderId: '',
                providerPaymentMethodId: '',
                created: new Date().toISOString(),
            }}
            handleSubmit={createRecord}
            {...props}
        />
    )
};